'use strict';

import { toaster } from '../../_assets/abbott/js/_material';

export default class FirstOrder {
  constructor() {}

  	/* Consider only first order. If staged plan is selected, first order is given by the 
  	** first stage having an actual number of orders
  	*/
  	getFirstOrderContainer(){
		let $productDetails = $('.phase--wrapper.active .product-details'),
			$firstOderContainer,
			hasProducts = false;

		if($productDetails.length > 1){
			let $numberOrdersInput;

			$productDetails.each(function () {
				let $this = $(this),
					nSelectedProducts = $this.find('.product-details__row').length;

				$numberOrdersInput = $this.find('.counter-value');

				if(nSelectedProducts > 0){
					if(parseInt($numberOrdersInput.val()) > 0 )
						$firstOderContainer = $this; 
					else
						toaster('Number of orders cannot be zero if products have been selected.', 'error');

					hasProducts = true;
					return false; 
				}

			});

			if(!hasProducts){
				toaster('Must select at least 1 product.', 'error');
				return;
			}

		}
		else
			$firstOderContainer = $productDetails.first();

		return $firstOderContainer;
	};

	/* Only first order is considered for SOH. 
	** Prepare values to send when calling the API. 
	** Values will be defined by regimen values, unless user selects to override first order
	**/ 
	getFirstOrderProducts(){
		let $firstOderContainer,
			$firstOrderProductRow,
			prodObj = {},
			_firstOrderProducts = [],
			isOrderOverride = $('.form--order-override').is(':visible'),
			that = this;

		if(isOrderOverride)
			$firstOderContainer = $('.form--order-override');
		else
			$firstOderContainer = that.getFirstOrderContainer();

		if(typeof $firstOderContainer === 'undefined'){
			return;
		}

		$firstOrderProductRow = $firstOderContainer.find('.product-details__row');

		$firstOrderProductRow.each(function () {
			let $this = $(this),
				isMixed = $this.find('.flavours-listing li[data-name="Mixed"]').hasClass('selected');

				prodObj = {};
				prodObj.Id = isMixed == true ? null : $this.find('.flavours-listing li.selected').data('prod-id');
				prodObj.MixedFlavour = isMixed;
				prodObj.ProductTypeId = $this.data('prod-type-id');
				prodObj.Quantity = $this.find('.product-quantity__value .counter-value').val();

			_firstOrderProducts.push(prodObj);
		});

		return _firstOrderProducts;
	};

}
